import { useEffect, useState } from 'react'

import { Flex, HStack, Image, Text, useMediaQuery } from '@chakra-ui/react'
import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'

import checkedImage from '@core/assets/images/validation_checked.svg'
import uncheckedImage from '@core/assets/images/validation_error.svg'

interface Props {
    password: string
    special?: boolean
}

export interface IValidation {
    chars: boolean
    case: boolean
    digit: boolean
    nonAlphanumeric: boolean
}

export const Validation = ({ password, special }: Props) => {
    const [desktop] = useMediaQuery('(min-width: 1230px)', {
        fallback: false,
    })
    const [valid, setValid] = useState<IValidation>({
        chars: false,
        case: false,
        digit: false,
        nonAlphanumeric: false,
    })
    const { t } = useTranslation()

    const { values } = useFormikContext<{ email: string; password: string }>()

    const validLength = (string: string) => {
        let flag: boolean = false
        const chars = /.{8,64}/
        if (string.match(chars)) flag = true

        setValid((prevState) => {
            return { ...prevState, chars: flag }
        })
    }

    const validCase = (string: string) => {
        let flag: boolean
        const upper = /(?=.*[A-Z])/
        const lower = /(?=.*[a-z])/

        if (string.match(upper) && string.match(lower)) flag = true
        else flag = false

        setValid((prevState) => {
            return { ...prevState, case: flag }
        })
    }

    const validDigit = (string: string) => {
        let flag: boolean
        const digit = /(?=.*\d)/

        if (string.match(digit)) flag = true
        else flag = false

        setValid((prevState) => {
            return { ...prevState, digit: flag }
        })
    }

    const validNonAlphanumeric = (string: string) => {
        let flag: boolean
        const chars = /(?=.*[^a-zA-Z0-9])/

        if (string.match(chars)) flag = true
        else flag = false

        setValid((prevState) => {
            return { ...prevState, nonAlphanumeric: flag }
        })
    }

    useEffect(() => {
        validLength(values.password)
        validCase(values.password)
        validDigit(values.password)
        validNonAlphanumeric(values.password)
    }, [values.password])
    return (
        <>
            {desktop && !special ? (
                <Flex
                    w={'full'}
                    flexDirection={'column'}
                    gap={3}
                    bg={'transparent'}
                    mt={0}
                    borderRadius={0}
                    px={0}
                    py={0}
                    display={'flex'}
                >
                    <Text fontSize={'xs'} color={'text.main'} fontWeight={'semibold'}>
                        {t('5214')}
                    </Text>
                    <HStack gap={2}>
                        <Image src={valid.chars ? checkedImage : uncheckedImage} />
                        <Text fontSize={'sm'} color={'text.secondary'}>
                            8-64 {t('6601')}
                        </Text>
                    </HStack>
                    <HStack gap={2}>
                        <Image src={valid.case ? checkedImage : uncheckedImage} />
                        <Text fontSize={'sm'} color={'text.secondary'}>
                            {t('6602')}
                        </Text>
                    </HStack>
                    <HStack gap={2}>
                        <Image src={valid.digit ? checkedImage : uncheckedImage} />
                        <Text fontSize={'sm'} color={'text.secondary'}>
                            {t('4726')}
                        </Text>
                    </HStack>
                    <HStack gap={2}>
                        <Image src={valid.nonAlphanumeric ? checkedImage : uncheckedImage} />
                        <Text fontSize={'sm'} color={'text.secondary'}>
                            {t('6603')}
                        </Text>
                    </HStack>
                </Flex>
            ) : (
                <Flex
                    w={'full'}
                    flexDirection={'column'}
                    gap={2}
                    bg={'bg.5'}
                    mt={1}
                    borderRadius={'4px'}
                    px={4}
                    py={2}
                    display={'flex'}
                >
                    <Text fontSize={'xs'} color={'text.main'} fontWeight={'semibold'}>
                        {t('5214')}
                    </Text>
                    <HStack gap={2}>
                        <Image src={valid.chars ? checkedImage : uncheckedImage} />
                        <Text fontSize={'sm'} color={'text.secondary'}>
                            8-64 {t('6601')}
                        </Text>
                    </HStack>
                    <HStack gap={2}>
                        <Image src={valid.case ? checkedImage : uncheckedImage} />
                        <Text fontSize={'sm'} color={'text.secondary'}>
                            {t('6602')}
                        </Text>
                    </HStack>
                    <HStack gap={2}>
                        <Image src={valid.digit ? checkedImage : uncheckedImage} />
                        <Text fontSize={'sm'} color={'text.secondary'}>
                            {t('4726')}
                        </Text>
                    </HStack>
                    <HStack gap={2}>
                        <Image src={valid.nonAlphanumeric ? checkedImage : uncheckedImage} />
                        <Text fontSize={'sm'} color={'text.secondary'}>
                            {t('6603')}
                        </Text>
                    </HStack>
                </Flex>
            )}
        </>
    )
}
